'use client';

import { GoogleMapsLoader } from 'components/google-maps-loader';
import { Conditional, HeaderStoreLocationMap } from 'components/pcc-components';
import { useHideMaps } from 'hooks/use-hide-maps';

export const StoreMapClient = ({ latitude, longitude }) => {
  const { isHidingMaps, userCountryCode, dealerCode } = useHideMaps();
  const showStoreLocationMap = !!(longitude && latitude);

  return (
    <Conditional test={!isHidingMaps && showStoreLocationMap}>
      <GoogleMapsLoader>
        <HeaderStoreLocationMap
          latitude={latitude}
          longitude={longitude}
          userCountryCode={userCountryCode}
          dealerCode={dealerCode}
        />
      </GoogleMapsLoader>
    </Conditional>
  );
};
